import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import Password from '../../../components/Password';
import Button from '../../../components/Button';

import ServiceRegistration from '../../../services/RegisterService';

const HuntingCreatePassword = () => {
  const [showConfirmation, setConfirmation] = useState(false);
  const [password, setPassword] = useState<string | undefined>('');
  const [disableButton, setDisableButton] = useState(false);

  const serviceRegistration = new ServiceRegistration();

  const navigate = useNavigate();

  const param = useLocation();
  const search = new URLSearchParams(param.search);
  const token = search.get('token')?.toString();

  const change = () => {
    setDisableButton(true);
    if (token && password && showConfirmation) {
      serviceRegistration
        .activateHunting(token, password)
        .then(() => {
          navigate('/hunting/email/confirmation');
        })
        .catch(() => {
          navigate('/confirmation-account');
        });
    }
    setDisableButton(false);
  };

  const changePassword = (e: any) => {
    setConfirmation(e?.isValid);
    if (e.target) {
      setPassword(e.target.value);
    }
  };

  return (
    <div
      id="mp__hunting-password"
      className="container m-auto grid justify-center items-center py-14 px-5 sm:px-10 md:px-20 text-xs md:text-base leading-5"
    >
      <span className="text-2xl font-semibold md:text-center">Cadastro de senha</span>
      <p className="md:px-20 max-w-[50rem] text-justify break-words pt-4 pb-3">
        Para continuar com o seu cadastro aqui na Via e por motivos de segurança, crie uma senha no
        campo abaixo.
      </p>
      <p className="md:px-20 max-w-[50rem] text-justify break-words pt-3 pb-4">
        É com ela que você vai acessar a sua área no nosso marketplace no futuro. Depois de
        confirmar, você vai receber um email com os próximos passos.
      </p>
      <div className="md:px-20 pt-5">
        <Password onChange={(e: any) => changePassword(e)} />
      </div>
      <div className="md:px-20 mt-12 mb-24 md:mb-36">
        <Button
          text={'Cadastrar'}
          type={'submit'}
          variant="primary"
          onClick={change}
          disabled={disableButton}
        />
      </div>
    </div>
  );
};

export default HuntingCreatePassword;
